import {
    IDataArray,
    DataArray
} from '../index';


export class FMIProductSource implements IDataArray {
    public Id: number;
    //public ProductSourceId: number;
    public ProductSourceID: number;
    public Name: string;
    public Active: boolean;
    public LastModified: Date;

    public GetById(): number {
        return this.Id;
    }
}
